import { useEffect, useState } from "react";
import { useParams } from "react-router-dom"; 
import axios from "axios";
import { baseurl } from "../../../component/Baseurl";
import stop1 from "../../../component/img/stop_1.png"; 
import CommitBooking from "../../Agents/FlightComp/CommitBooking";
import Navbar from "../../../component/Navbar";
import FlightFareRules from "../../Agents/FlightComp/FlightFareRules";


function VisitorFlightDetail() {
  const { token } = useParams();
  // const [updateFareQuoteResponse, setUpdateFareQuoteResponse] = useState(null);
  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(null);

  const [updateFareQuoteResponse, setUpdateFareQuoteResponse] = useState(null);
  const [priceDetails, setPriceDetails] = useState(null);
  const [flightAttr, setFlightAttr] = useState(null);
  const [flightDetails, setFlightDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    if (!token) return;
  
    const fetchUpdateFareQuote = async () => {
      try {
        const response = await axios.post(`${baseurl}fetchUpdateFareQuote`, {
          ResultToken: token,
        });
  
        // console.log("Update Fare Quote API Response:", response.data);
  
        const fareQuote = response.data?.UpdateFareQuoteResponse?.UpdateFareQuote || {};
  
        // Set the full response first
        setUpdateFareQuoteResponse(fareQuote);
  
        // Extract details safely
        if (fareQuote?.FareQuoteDetails) {
          setPriceDetails(fareQuote.FareQuoteDetails.Price || {});
          setFlightAttr(fareQuote.FareQuoteDetails.Attr || {});
          setFlightDetails(
            fareQuote.FareQuoteDetails.JourneyList?.FlightDetails?.Details?.[0]?.[0] || {}
          );
        }
        
      } catch (err) {
        setError("Failed to fetch fare quote details.");
      } finally {
        setLoading(false);
      }
    };
  
    fetchUpdateFareQuote();
  }, [token]);
  
  // Log updated state after it is set
  useEffect(() => {
    console.log("Updated updateFareQuoteResponse:", updateFareQuoteResponse);
    // console.log("Price Details:", priceDetails);
    // console.log("Flight Attributes:", flightAttr);
    // console.log("Flight Details:", flightDetails);
  }, [updateFareQuoteResponse, priceDetails, flightAttr, flightDetails]);
  


  const agentid = '0';

  console.log("agent id",agentid );
  
    const [flightMarkup, setFlightMarkup] = useState(0); // Initialize with 0
  
    useEffect(() => {
      if (!agentid) return console.error("No agent ID found in localStorage");
    
      const fetchMarkupDetails = async () => {
        try {
          const { data } = await axios.get(`${baseurl}getMarkupDetailsById/${agentid}`);
    
          if (data?.message === "Markup details fetched successfully") {
            const admin_flight_markup = Number(data.adminMarkup.admin_flight_markup) || 0;
            const distributor_hotel_markup = Number(data.distributorMarkup.distributor_hotel_markup) || 0;
             
    
            const totalMarkup = admin_flight_markup ;
    
            console.log("Flight Total Markup Amount:", totalMarkup);
            setFlightMarkup(totalMarkup); // Update state correctly
          } else {
            console.error("Unexpected API response", data);
          }
        } catch (error) {
          console.error("API Error:", error);
        }
      };
    
      fetchMarkupDetails();
    }, [agentid]);




  return (
    <>
      <Navbar/>
      <div className="container bg-light p-4 mt-3 rounded shadow">
        {loading && <p>Loading...</p>}
        {error && <p className="text-danger">{error}</p>}

        {updateFareQuoteResponse && (
          <>


<div className="rounded border">
  <div className="row p-3 text-dark">
    <div className="col-3 d-flex align-items-center justify-content-center">
    <div className="fltname">
    {updateFareQuoteResponse?.FareQuoteDetails?.JourneyList?.FlightDetails?.Details?.[0]?.[0]?.OperatorName || "N/A"}
      </div>
    </div>
    <div className="col-6 d-flex align-items-center justify-content-center">
                                <div className="d-flex justify-content-around align-items-center">
                                  <div className="me-3">
                                  <div className="lmo9">
  {(() => {
    const rawDateTime = updateFareQuoteResponse?.FareQuoteDetails?.JourneyList?.FlightDetails?.Details?.[0]?.[0]?.Origin?.DateTime;
    
    if (!rawDateTime) return "N/A";

    const date = new Date(rawDateTime);

    const formattedDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    const formattedTime = date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return `${formattedDate}  ${formattedTime}`;
  })()}
</div>

                                    <div className="lmo9">
                                    {updateFareQuoteResponse?.FareQuoteDetails?.JourneyList?.FlightDetails?.Details?.[0]?.[0]?.Origin?.CityName || "N/A"}
                                       {" "}
                                      
                                    </div>
                                  </div>
    
                                  <div className="me-3">
                                    <div className="lmo9">
                                    {updateFareQuoteResponse?.FareQuoteDetails?.JourneyList?.FlightDetails?.Details?.[0]?.[0]?.Duration || "N/A"}
&nbsp;mins
                                    </div>
                                    <div>
                                      <img src={stop1} className="img-fluid" />
                                    </div>
                                    <div className="lmo9">
                                      Stop :  {updateFareQuoteResponse?.FareQuoteDetails?.JourneyList?.FlightDetails?.Details?.[0]?.[0]?.stop_over || "N/A"}
                                    </div>
                                  </div>
    
                                  <div className="me-2">
                                    <div className="lmo9">

                                    {(() => {
    const rawDateTime = updateFareQuoteResponse?.FareQuoteDetails?.JourneyList?.FlightDetails?.Details?.[0]?.[0]?.Destination?.DateTime;
    
    if (!rawDateTime) return "N/A";

    const date = new Date(rawDateTime);

    const formattedDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    const formattedTime = date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return `${formattedDate}  ${formattedTime}`;
  })()}


                                    {/* {updateFareQuoteResponse?.FareQuoteDetails?.JourneyList?.FlightDetails?.Details?.[0]?.[0]?.Destination?.DateTime || "N/A"} */}
                                    </div>
                                    <div className="lmo9">
                                    {updateFareQuoteResponse?.FareQuoteDetails?.JourneyList?.FlightDetails?.Details?.[0]?.[0]?.Destination?.CityName || "N/A"}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-3 d-flex align-items-center justify-content-center">
 
<div className="text-dark price121 font3">
₹{(updateFareQuoteResponse?.FareQuoteDetails?.JourneyList?.Price?.TotalDisplayFare || "N/A" ) + flightMarkup} 
</div>



</div>

  </div>



<div className="text-start p-3">
 <div className="row">
  <div className="col-md-4 text-dark">
    <div><strong>Baggage : </strong>{updateFareQuoteResponse?.FareQuoteDetails?.JourneyList?.FlightDetails?.Details?.[0]?.[0]?.Attr?.Baggage || "N/A"}</div>
    <div><strong>Cabin Baggage : </strong>{updateFareQuoteResponse?.FareQuoteDetails?.JourneyList?.FlightDetails?.Details?.[0]?.[0]?.Attr?.CabinBaggage || "N/A"}</div>
  </div>
  <div className="col-md-4 text-dark">
  <div>
  <strong>Is Refundable : </strong>
  {updateFareQuoteResponse?.FareQuoteDetails?.JourneyList?.Attr?.IsRefundable !== undefined
    ? updateFareQuoteResponse.FareQuoteDetails.JourneyList.Attr.IsRefundable
      ? "Yes"
      : "No"
    : "N/A"}
</div>

  <div><strong>Fare Type : </strong>{updateFareQuoteResponse?.FareQuoteDetails?.JourneyList?.Attr?.FareType || "N/A" }</div>
  <div><strong>Airline Remark : </strong>{updateFareQuoteResponse?.FareQuoteDetails?.JourneyList?.Attr?.AirlineRemark || "N/A" }</div>
  </div>



  <div className="col-md-4 text-dark"> 
  <div><strong>No Of Adult : </strong>{updateFareQuoteResponse?.FareQuoteDetails?.JourneyList?.Price?.PassengerBreakup?.ADT?.PassengerCount || "N/A" }</div>
  <div><strong>No Of Child : </strong>{updateFareQuoteResponse?.FareQuoteDetails?.JourneyList?.Price?.PassengerBreakup?.CHD?.PassengerCount || "N/A" }</div>
  <div><strong>Base Price : </strong>{(updateFareQuoteResponse?.FareQuoteDetails?.JourneyList?.Price?.PriceBreakup?.BasicFare || "N/A" ) + flightMarkup}</div>
  <div><strong>Tax : </strong>{updateFareQuoteResponse?.FareQuoteDetails?.JourneyList?.Price?.PriceBreakup?.Tax || "N/A" }</div>
  </div>



 </div>
 
 
 
 
 
</div>

</div>

          

            
          </>
        )}
      </div>


<div>
  {/* <FlightExtraService/> */}
</div>

<FlightFareRules/>
 
<CommitBooking 
adt = {updateFareQuoteResponse?.FareQuoteDetails?.JourneyList?.Price?.PassengerBreakup?.ADT?.PassengerCount || "N/A" }
chd = {updateFareQuoteResponse?.FareQuoteDetails?.JourneyList?.Price?.PassengerBreakup?.CHD?.PassengerCount || "N/A" }

/>

<div>

</div>



    </>
  );
}

export default VisitorFlightDetail;
